import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import classIcon from "/custom-class-icon.svg";
import keyIcon from "/custom-key-icon.svg";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { AccessModal } from "../components/AccessModal";

export const TeacherHome: React.FC = () => {
  const navigate = useNavigate();
  const [handleAccessModalOpen, setHandleAccessModalOpen] = useState(false);

  // 檢查用戶是否為教師身份
  useEffect(() => {
    const checkTeacherAccess = () => {
      const userDataString = localStorage.getItem("oidc.user:https://id.hle.com.tw:js");
      
      if (!userDataString) {
        navigate("/");
        return;
      }

      try {
        const userData = JSON.parse(userDataString);
        const userRole = userData.profile?.role || userData.profile?.['custom:role'] || "學生";
        
        if (userRole !== "老師") {
          navigate("/student-home");
        }
      } catch (error) {
        console.error("解析用戶資料失敗:", error);
        navigate("/");
      }
    };

    checkTeacherAccess();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Header />
      <main className="flex-1 flex justify-center items-center select-none">
        <div className="flex justify-center items-center h-full lg:gap-20 gap-10 sm:text-3xl text-xl text-black/70 flex-col md:flex-row">
          <div
            onClick={() => navigate("/teacher/correcting-records")}
            className="bg-[#e0ebf1] rounded-xl shadow-lg px-10 py-6 hover:shadow-xl transition-all duration-200 hover:translate-y-[-5px] cursor-pointer flex justify-center items-center flex-col gap-6 sm:w-80 sm:h-80 w-60 h-60 backdrop-filter backdrop-blur-sm"
          >
            <img
              className="aspect-square sm:w-32 sm:h-32 w-24 h-24"
              src={classIcon}
              alt=""
            />
            <p className="font-medium tracking-wider">班級批改紀錄</p>
          </div>
          <div
            onClick={() => {
              setHandleAccessModalOpen(true);
            }}
            className="bg-[#f8f1dc] rounded-xl shadow-lg px-10 py-6 hover:shadow-xl transition-all duration-200 hover:translate-y-[-5px] cursor-pointer flex justify-center items-center flex-col gap-6 sm:w-80 sm:h-80 w-60 h-60 backdrop-filter backdrop-blur-sm"
          >
            <img
              className="aspect-square sm:w-32 sm:h-32 w-24 h-24"
              src={keyIcon}
              alt=""
            />
            <p className="font-medium tracking-wider">輸入教師開通碼</p>
          </div>
        </div>
      </main>
      <Footer />
      <AccessModal
        open={handleAccessModalOpen}
        onClose={() => setHandleAccessModalOpen(false)}
      />
    </div>
  );
};